import "./Header.css";
import { useSelector } from "react-redux/es/exports";
import classes from "./Header.module.css";
import Button from "react-bootstrap/Button";
import HeaderLogo from "../../assets/logo/header_profile_image.png";
import { RootState } from "../../redux/store";
import { useGetWell } from "../Helper/useGetWell";
import { useGetPlatform } from "../Helper/useGetPlatform";
import {
  SelectedNode,
  TreeChild1,
  TreeChild2,
} from "../../redux/reducers/AssetReducer";

const Header = () => {
  const selectedNode: SelectedNode = useSelector(
    (state: RootState) => state.asset.selectedNode
  );

  const activePage: string = useSelector(
    (state: RootState) => state.ui.activePage
  );


  let well: TreeChild2 = useGetWell(selectedNode.id);
  let platform: TreeChild1 = useGetPlatform(selectedNode.id);
  let totalPlatform = 0;
  let onlineWell = 0;
  let idleWell = 0;

  if (platform.hasOwnProperty("children")) {
    totalPlatform = platform.children!.length;
    for (let i = 0; i < platform.children!.length; i++) {
      if (platform.children![i].metadata["well-type"] === "Shut-In") {
        idleWell++;
      } else {
        onlineWell++;
      }
    }
  }

  return (
    <header className={classes.header}>
      <div className={classes.left}>
        <div className={classes.circle}>
          <img
            src={HeaderLogo}
            className={classes["header-logo"]}
            alt="Header Logo"
          />
        </div>
      </div>
      <div className={classes["wrap-section"]}>
        {activePage === "Assets" && selectedNode.id !== null ? (
          <>
            {selectedNode.level === 4 ? (
              <div className={classes.middle}>
                <div className={classes["header-title"]}>
                  {selectedNode.name}
                </div>
                <div className={classes["ver-text"]}>
                  <div>{well!.metadata["well-type"]} Well</div>
                  <div>{well!.metadata["well-type"]} Lift</div>
                </div>
              </div>
            ) : selectedNode.level === 3 ? (
              <div className={classes.middle}>
                <div className={classes["header-title"]}>
                  {selectedNode.name} Platform
                </div>
                <div className={classes["ver-text"]}>
                  <div>{platform!.metadata["type"]} Platform</div>
                  <div className={classes["detail-desc"]}>
                    {totalPlatform} Total Wells
                    {totalPlatform !== 0 && onlineWell > 1 && idleWell > 1 && (
                      <div>
                        &nbsp;| {onlineWell} Online Wells & {idleWell} Idle
                        Wells
                      </div>
                    )}
                    {totalPlatform !== 0 &&
                      onlineWell > 1 &&
                      idleWell === 0 && (
                        <div>&nbsp;| {onlineWell} Online Wells</div>
                      )}
                    {totalPlatform !== 0 &&
                      onlineWell === 0 &&
                      idleWell > 1 && <div>&nbsp;| {idleWell} Idle Wells</div>}
                    {totalPlatform !== 0 &&
                      onlineWell === 1 &&
                      idleWell > 1 && (
                        <div>
                          &nbsp;| {onlineWell} Online Well & {idleWell} Idle
                          Wells
                        </div>
                      )}
                    {totalPlatform !== 0 &&
                      onlineWell > 1 &&
                      idleWell === 1 && (
                        <div>
                          &nbsp;| {onlineWell} Online Wells & {idleWell} Idle
                          Well
                        </div>
                      )}
                    {totalPlatform !== 0 &&
                      onlineWell === 1 &&
                      idleWell === 0 && (
                        <div>&nbsp;| {onlineWell} Online Well</div>
                      )}
                    {totalPlatform !== 0 &&
                      onlineWell === 0 &&
                      idleWell === 1 && <div>&nbsp;| {idleWell} Idle Well</div>}
                    {totalPlatform !== 0 &&
                      onlineWell === 1 &&
                      idleWell === 1 && (
                        <div>
                          &nbsp;| {onlineWell} Online Well & {idleWell} Idle
                          Well
                        </div>
                      )}
                  </div>
                </div>
              </div>
            ) : [1, 2].includes(selectedNode.level) ? (
              <div className={classes.middle}>
                <div className={classes["header-title"]}>
                  {selectedNode.name}
                </div>
              </div>
            ) : (
              <div className={classes.middle}>
                <div className={classes["header-title"]}>My Assets</div>
              </div>
            )}
            <div className="right">
              <Button
                className={classes.button}
                type="submit"
                variant="primary"
              >
                Save
              </Button>
            </div>
          </>
        ) : activePage === "Assets"  ? (
          <div className={classes.middle}>
            <div className={classes["header-title"]}>My Assets</div>
          </div>
        ) : activePage === "Tests" ? (
          <div className={classes.middle}>
            <div className={classes["header-title"]}>Tests Page</div>
          </div>
        // ) : activePage === "Tests" && !pageState.testsPage.isFirstAccessed ? (
        //   <div className={classes.middle}>
        //     <div className={classes["header-title"]}>Tests Page "Accessed"</div>
        //   </div>
        // )
        ) : activePage === "Allocation" ? (
          <>
            {selectedNode.id !== null ? (
              <>
                {selectedNode.level === 4 ? (
                  <div className={classes.middle}>
                    <div className={classes["header-title"]}>
                      {selectedNode.name}
                    </div>
                    <div className={classes["ver-text"]}>
                      <div>{well!.metadata["well-type"]} Well</div>
                      <div>{well!.metadata["well-type"]} Lift</div>
                    </div>
                  </div>
                ) : selectedNode.level === 3 ? (
                  <div className={classes.middle}>
                    <div className={classes["header-title"]}>
                      {selectedNode.name} Platform
                    </div>
                    <div className={classes["ver-text"]}>
                      <div>{platform!.metadata["type"]} Platform</div>
                      <div className={classes["detail-desc"]}>
                        {totalPlatform} Total Wells
                        {totalPlatform !== 0 && onlineWell > 1 && idleWell > 1 && (
                          <div>
                            &nbsp;| {onlineWell} Online Wells & {idleWell} Idle
                            Wells
                          </div>
                        )}
                        {totalPlatform !== 0 &&
                          onlineWell > 1 &&
                          idleWell === 0 && (
                            <div>&nbsp;| {onlineWell} Online Wells</div>
                          )}
                        {totalPlatform !== 0 &&
                          onlineWell === 0 &&
                          idleWell > 1 && <div>&nbsp;| {idleWell} Idle Wells</div>}
                        {totalPlatform !== 0 &&
                          onlineWell === 1 &&
                          idleWell > 1 && (
                            <div>
                              &nbsp;| {onlineWell} Online Well & {idleWell} Idle
                              Wells
                            </div>
                          )}
                        {totalPlatform !== 0 &&
                          onlineWell > 1 &&
                          idleWell === 1 && (
                            <div>
                              &nbsp;| {onlineWell} Online Wells & {idleWell} Idle
                              Well
                            </div>
                          )}
                        {totalPlatform !== 0 &&
                          onlineWell === 1 &&
                          idleWell === 0 && (
                            <div>&nbsp;| {onlineWell} Online Well</div>
                          )}
                        {totalPlatform !== 0 &&
                          onlineWell === 0 &&
                          idleWell === 1 && <div>&nbsp;| {idleWell} Idle Well</div>}
                        {totalPlatform !== 0 &&
                          onlineWell === 1 &&
                          idleWell === 1 && (
                            <div>
                              &nbsp;| {onlineWell} Online Well & {idleWell} Idle
                              Well
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                ) : [1, 2].includes(selectedNode.level) ? (
                  <div className={classes.middle}>
                    <div className={classes["header-title"]}>
                      {selectedNode.name}
                    </div>
                  </div>
                ) : (
                  <div className={classes.middle}>
                    <div className={classes["header-title"]}>Allocation</div>
                  </div>
                )}
                <div className="right">
                  <Button
                    className={classes.button}
                    type="submit"
                    variant="primary"
                  >
                    Save
                  </Button>
                </div>
              </>
            ) : (
              <div className={classes.middle}>
                <div className={classes["header-title"]}>Allocation Page</div>
              </div>
            )}
          </>
        // : activePage === "Allocation" && !pageState.allocationPage.isFirstAccessed ? (
        //   <div className={classes.middle}>
        //     <div className={classes["header-title"]}>Allocation Page "Accessed"</div>
        //   </div>
        // )
        ) : activePage === "Users" && (
          <div className={classes.middle}>
            <div className={classes["header-title"]}>Users Page</div>
          </div>
        )}
        {/* //  : activePage === "Users" && !pageState.allocationPage.isFirstAccessed && (
        //   <div className={classes.middle}>
        //     <div className={classes["header-title"]}>Users Page "Accessed"</div>
        //   </div>
        // )} */}
      </div>
    </header>
  );
};

export default Header;
